@if (isReadOnly()) {
  <div class="w-full h-full flex flex-col gap-6">
    <div class="w-full flex-col">
      <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Project and Approver(s)</div>
      <div class="flex gap-10">
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Project</div>
          <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{template()?.project?.code ?? "No project set."}}</div>
        </div>
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Line Manager/Primary Approver</div>
          <div class="self-stretch justify-start text-surface-300 text-sm font-semibold font-['Inter'] line-clamp-1">Not Available</div>
        </div>
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Funding Manager/Secondary Approver</div>
          <div class="self-stretch justify-start text-surface-300 text-sm font-semibold font-['Inter'] line-clamp-1">Not Available</div>
        </div>
      </div>
    </div>
    <div class="w-full h-[1px] bg-surface-200"></div>
    <div class="w-full flex-col">
      <div class="self-stretch justify-start text-text-color text-base font-medium font-['Inter'] leading-6">Purpose of Travel</div>
      <div class="flex gap-10">
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">Purpose</div>
          <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{template()?.purpose ?? "No purpose set."}}</div>
        </div>
        <div class="flex flex-col min-w-1/4">
          <div class="self-stretch justify-start text-text-color text-sm font-normal font-['Inter'] leading-5">More Details</div>
          <div class="self-stretch justify-start text-text-color text-sm font-semibold font-['Inter'] line-clamp-1">{{template()?.purposeNotes ?? "No details set."}}</div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="w-full h-full flex flex-col gap-6">
    <p-card>
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Project and Approver</div>
          <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">Select the project.</div>
          <div class="self-stretch justify-start text-surface-600 text-sm font-light font-['Inter']">The TA Approver will be selected when creating a TA based on this template.</div>
        </div>
        <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4 ">
          <div class="flex-col gap-2 flex-1">
            <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Project</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
            <p-autocomplete [ngModel]="template()?.project"
                            (onSelect)="updateProject($event)"
                            [dropdown]="true"
                            [suggestions]="filteredProjects"
                            (completeMethod)="filterProjects($event)"
                            optionLabel="code"
                            placeholder="Type and/or select a project..."
                            size="small"
                            class="w-full"
                            [forceSelection]="true"
                            appendTo="body"
                            data-testid="template-project"
            >
              <ng-template #item let-project>
                <span>{{ project.code }}</span>
              </ng-template>
            </p-autocomplete>
          </div>
          <div class="flex-col gap-2 flex-1">
            <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">TA Approver</span></div>
            <p-select placeholder="Not available in a template"
                      size="small"
                      class="w-full"
                      disabled
            ></p-select>
          </div>
        </div>
      </div>
    </p-card>

    <p-card>
      <div class="flex gap-2">
        <div class="flex flex-col w-64 bg-surface-0 p-6 gap-6 rounded-l-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)]">
          <div class="self-stretch justify-start text-surface-800 text-base font-medium font-['Inter'] leading-6">Purpose of the Travel</div>
        </div>
        <div class="flex-1 bg-surface-50 p-6 rounded-r-2xl shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10),0px_1px_3px_0px_rgba(0,0,0,0.10)] flex gap-4">
          <div class="flex-col gap-2 flex-1">
            <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Purpose of the Travel</span><span class="text-red-700 text-sm font-normal font-['Inter'] leading-5">*</span></div>
            <p-autocomplete [ngModel]="template()?.purpose"
                            (onSelect)="updatePurpose($event)"
                            [dropdown]="true"
                            [suggestions]="filteredPurposes"
                            (completeMethod)="filterPurposes($event)"
                            optionLabel="label"
                            placeholder="Purpose of the travel..."
                            size="small"
                            class="w-full"
                            [forceSelection]="true"
                            data-testid="template-purpose"
            ></p-autocomplete>
          </div>
          <div class="flex-col gap-2 flex-1">
            <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">More Details</span></div>
            <textarea pTextarea
                      [value]="template()?.purposeNotes ?? ''"
                      (change)="updatePurposeNotes($event)"
                      [autoResize]="true"
                      data-testid="template-purpose-notes"
                      placeholder="Provide more details..."
                      rows="1"
                      pSize="small"
                      class="w-full"
                      [disabled]="!template()?.purpose"
            ></textarea>
          </div>
        </div>
      </div>
    </p-card>
  </div>
}
